


























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const DatePicker = require("v-calendar/lib/components/date-picker.umd");

interface ICalender {
  date: Date | null;
}

@Component({
  components: { DatePicker },
})
export default class Calendar extends Vue {
  name: "Calendar";
  private isShowCalender = false;

  @Model("on-day-click", { type: Date, default: null })
  targetDate: Date | null;

  @Prop({ required: true })
  private id!: string;

  private onClickCalenderText(): void {
    this.isShowCalender = !this.isShowCalender;
  }

  private onDayClick(calender: ICalender): void {
    this.isShowCalender = false;
    this.$emit("on-day-click", calender.date);
  }

  get displayDate(): string {
    if (this.targetDate == null) {
      return "";
    }
    const year: number = this.targetDate.getFullYear();
    const month: number = this.targetDate.getMonth() + 1;
    const day: number = this.targetDate.getDate();
    const dayOfWeek = this.targetDate.getDay();
    const weeks = ["日", "月", "火", "水", "木", "金", "土"];
    return `${year}年${month}月${day}日(${weeks[dayOfWeek]})`;
  }
}
